module.exports = __webpack_public_path__ + "static/media/publish.4b0264f1.svg";